module.exports = __webpack_public_path__ + "static/media/ReportedUsers.0cb51e7a.png";